/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

export const SET_PROFILE = '@@nzr/renterQuestions/SET_PROFILE'
export const SET_FETCHED_PROFILE = '@@nzr/renterQuestions/SET_FETCHED_PROFILE'
